( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'video';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Load and play video on click
	 *
	 * @param {object} block
	 */
	const playVideo = ( block ) => {

		const button = block.querySelector( '.js-play-button' );
		const template = block.querySelector( '.video-template' );

		if ( button && template ) {

			button.addEventListener( 'click', () => {

				const video = template.content.cloneNode( true );

				template.replaceWith( video );
				button.classList.add( 'video-icon--hidden' );
				block.querySelector( '.video-image' ).classList.add( 'video-image--hidden' );

			} );

		}

	}

	/**
	 * Block init
	 *
	 * @param {object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {}

		// Block Code Here
		playVideo( block );

	};

} )();
